/* PumpDeals Alpine product interactions v1.5 */
document.addEventListener('DOMContentLoaded', () => {
  initAlpineProducts(document);
  initRecommendationSections(document);
});

document.addEventListener('shopify:section:load', event => {
  initAlpineProducts(event.target);
  initRecommendationSections(event.target);
});

function initAlpineProducts(scope) {
  if (scope.matches?.('[data-ap-product]')) initAlpineProduct(scope);
  scope.querySelectorAll?.('[data-ap-product]').forEach(initAlpineProduct);
}

function initAlpineProduct(root) {
  if (!root || root.dataset.ready === 'true') return;
  const variantData = root.querySelector('[data-ap-variants]');
  if (!variantData) return;

  let variants = [];
  try {
    variants = JSON.parse(variantData.textContent || '[]');
  } catch (error) {
    console.error('PumpDeals: variant data could not be parsed.', error);
    return;
  }
  if (!Array.isArray(variants) || variants.length === 0) return;

  root.dataset.ready = 'true';

  const variantInput = root.querySelector('[data-ap-variant-id]');
  const variantSelect = root.querySelector('[data-ap-variant-select]');
  const priceEls = root.querySelectorAll('[data-ap-price]');
  const compareEl = root.querySelector('[data-ap-compare]');
  const saveEl = root.querySelector('[data-ap-save]');
  const statusEl = root.querySelector('[data-ap-availability]');
  const statusDot = root.querySelector('[data-ap-status]');
  const addButtons = root.querySelectorAll('[data-ap-add]');
  const buyNow = root.querySelector('[data-ap-buy-now]');
  const qtyInput = root.querySelector('[data-ap-qty]');
  const formError = root.querySelector('[data-ap-form-error]');
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';

  const optionGroups = () => [...root.querySelectorAll('[data-ap-option-group]')];
  const selectedOptions = () => optionGroups().map(group =>
    group.querySelector('input[type="radio"]:checked')?.value ?? null
  );

  const variantForValues = values => variants.find(variant =>
    Array.isArray(variant.options) &&
    variant.options.length === values.length &&
    variant.options.every((option, index) => option === values[index])
  );

  const getVariant = () => {
    if (variantSelect) {
      return variants.find(variant => String(variant.id) === String(variantSelect.value)) || null;
    }
    const values = selectedOptions();
    if (values.length === 0) {
      return variants.find(variant => String(variant.id) === String(variantInput?.value)) || variants[0] || null;
    }
    return variantForValues(values) || null;
  };

  const setInputsFromVariant = variant => {
    if (!variant) return;
    if (variantSelect) {
      variantSelect.value = String(variant.id);
      return;
    }
    optionGroups().forEach((group, index) => {
      const value = variant.options?.[index];
      if (value == null) return;
      const input = [...group.querySelectorAll('input[type="radio"]')].find(item => item.value === value);
      if (input) input.checked = true;
    });
  };

  const showMedia = mediaId => {
    if (!mediaId) return;
    let found = false;
    root.querySelectorAll('[data-ap-media]').forEach(media => {
      const active = String(media.dataset.apMedia) === String(mediaId);
      media.classList.toggle('is-active', active);
      if (active) found = true;
    });
    if (!found) return;
    root.querySelectorAll('[data-ap-thumb]').forEach(thumb => {
      thumb.classList.toggle('is-active', String(thumb.dataset.apThumb) === String(mediaId));
    });
  };

  const refreshOptionAvailability = () => {
    if (variantSelect) return;
    optionGroups().forEach((group, groupIndex) => {
      group.querySelectorAll('input[type="radio"]').forEach(input => {
        // Keep any value selectable when at least one purchasable variant uses it.
        // If the current combination is invalid, the change handler moves the
        // remaining options to a valid variant containing the value just chosen.
        const possible = variants.some(variant =>
          variant.available && variant.options?.[groupIndex] === input.value
        );
        input.disabled = !possible;
        input.setAttribute('aria-disabled', String(!possible));
      });
    });
  };

  const syncOptionLabels = () => {
    selectedOptions().forEach((value, index) => {
      const label = root.querySelector(`[data-ap-option-value="${index}"]`);
      if (label) label.textContent = value || '';
    });
  };

  const syncConfigSummary = variant => {
    if (!variant) return;
    const parts = Array.isArray(variant.config_parts) && variant.config_parts.length
      ? variant.config_parts
      : String(variant.title || '').split(' | ');

    root.querySelectorAll('[data-ap-config-part]').forEach(element => {
      const index = Number(element.dataset.apConfigPart);
      element.textContent = parts[index] || '—';
    });
    root.querySelectorAll('[data-ap-selected-config]').forEach(element => {
      element.textContent = variant.title || '';
    });
    root.querySelectorAll('[data-ap-sku]').forEach(element => {
      element.textContent = variant.sku || '—';
    });
    root.querySelectorAll('[data-ap-variant-row]').forEach(row => {
      row.classList.toggle('is-selected', String(row.dataset.apVariantRow) === String(variant.id));
    });
  };

  const renderVariant = variant => {
    refreshOptionAvailability();
    syncOptionLabels();

    if (!variant) {
      if (variantInput) variantInput.value = '';
      if (statusEl) statusEl.textContent = root.dataset.unavailableText || 'Nicht verfügbar';
      if (statusDot) statusDot.classList.add('is-unavailable');
      addButtons.forEach(button => { button.disabled = true; });
      if (buyNow) buyNow.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = String(variant.id);
    priceEls.forEach(element => {
      element.textContent = variant.price_formatted || '';
    });

    const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    if (compareEl) {
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? (variant.compare_at_price_formatted || '') : '';
    }
    if (saveEl) {
      saveEl.hidden = !onSale;
      saveEl.textContent = onSale
        ? `${root.dataset.saveText || 'Du sparst'} ${variant.saving_formatted || ''}`.trim()
        : '';
    }

    if (statusEl) {
      statusEl.textContent = variant.available
        ? (root.dataset.inStockText || 'Bestellbar')
        : (root.dataset.soldOutText || 'Nicht verfügbar');
    }
    if (statusDot) statusDot.classList.toggle('is-unavailable', !variant.available);
    addButtons.forEach(button => { button.disabled = !variant.available; });
    if (buyNow) buyNow.disabled = !variant.available;

    if (variant.featured_media_id) showMedia(variant.featured_media_id);
    syncConfigSummary(variant);

    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    root.dispatchEvent(new CustomEvent('pumpdeals:variant-change', {
      bubbles: true,
      detail: { variant }
    }));
  };

  const update = () => renderVariant(getVariant());

  if (variantSelect) {
    variantSelect.addEventListener('change', update);
  }

  root.addEventListener('change', event => {
    const input = event.target.closest?.('[data-ap-option]');
    if (!input || !root.contains(input)) return;

    let variant = getVariant();
    if (!variant || !variant.available) {
      const changedGroup = optionGroups().findIndex(group => group.contains(input));
      variant = variants.find(candidate =>
        candidate.available && candidate.options?.[changedGroup] === input.value
      ) || null;
      if (variant) setInputsFromVariant(variant);
    }
    renderVariant(variant || getVariant());
  });

  root.querySelectorAll('[data-ap-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => showMedia(thumb.dataset.apThumb));
  });

  root.querySelector('[data-ap-qty-minus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
  });

  root.querySelector('[data-ap-qty-plus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
  });

  const tabButtons = [...root.querySelectorAll('[data-ap-tab]')];
  const activateTab = button => {
    if (!button) return;
    const id = button.dataset.apTab;
    tabButtons.forEach(tab => {
      const active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-ap-panel]').forEach(panel => {
      const active = panel.dataset.apPanel === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  };

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => activateTab(button));
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let targetIndex = index;
      if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabButtons.length) % tabButtons.length;
      if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabButtons.length;
      if (event.key === 'Home') targetIndex = 0;
      if (event.key === 'End') targetIndex = tabButtons.length - 1;
      activateTab(tabButtons[targetIndex]);
      tabButtons[targetIndex].focus();
    });
  });

  root.querySelectorAll('[data-ap-choose-variant]').forEach(button => {
    button.addEventListener('click', () => {
      const variant = variants.find(item => String(item.id) === String(button.dataset.apChooseVariant));
      if (!variant || !variant.available) return;
      setInputsFromVariant(variant);
      renderVariant(variant);
      root.querySelector('.ap-details')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelector('[data-ap-variant-search]')?.addEventListener('input', event => {
    const query = event.target.value.trim().toLowerCase();
    root.querySelectorAll('[data-ap-variant-row]').forEach(row => {
      row.hidden = Boolean(query) && !row.textContent.toLowerCase().includes(query);
    });
  });

  buyNow?.addEventListener('click', async () => {
    const id = Number(variantInput?.value || 0);
    const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    if (!id || buyNow.disabled) return;

    const originalText = buyNow.textContent;
    buyNow.disabled = true;
    buyNow.textContent = root.dataset.processingText || 'Wird vorbereitet…';
    if (formError) formError.textContent = '';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id, quantity }] })
      });
      if (!response.ok) throw new Error(`Cart add failed (${response.status})`);
      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error('PumpDeals: buy-now failed.', error);
      buyNow.disabled = false;
      buyNow.textContent = originalText;
      if (formError) formError.textContent = root.dataset.cartErrorText || 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
    }
  });

  if (variantSelect) {
    const selected = variants.find(variant => String(variant.id) === String(variantInput?.value));
    if (selected) variantSelect.value = String(selected.id);
  }
  activateTab(tabButtons.find(button => button.classList.contains('is-active')) || tabButtons[0]);
  update();
}

function initRecommendationSections(scope) {
  const containers = [];
  if (scope.matches?.('[data-ap-recommendations-url]')) containers.push(scope);
  scope.querySelectorAll?.('[data-ap-recommendations-url]').forEach(container => containers.push(container));

  containers.forEach(async container => {
    if (container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true';
    try {
      const response = await fetch(container.dataset.apRecommendationsUrl, { credentials: 'same-origin' });
      if (!response.ok) return;
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const replacement = [...doc.querySelectorAll('[data-ap-recommendations-id]')].find(item =>
        item.dataset.apRecommendationsId === container.dataset.apRecommendationsId
      );
      if (replacement) container.innerHTML = replacement.innerHTML;
    } catch (error) {
      console.error('PumpDeals: recommendations could not be loaded.', error);
    }
  });
}
